import styled from 'styled-components'

const TextError = styled.p`
  color: red;
`

export { TextError }